import React from "react";
import styled from "styled-components";

export default styled.div`
    text-align: center;
    h2 {
        color: #5562C0;
        font-size: 32px;
        font-weight: 700;

    }
    h3 {
        font-size: 18px;
        line-height: 24px;
    }

    textarea {
        width: 471px;
        resize: none;
        height: 94px;
        margin: 0 auto;
        border-right: 1px solid #979797;
        padding: 10px;
    }

`;